import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Http, Response } from '@angular/http';
import { REDEEM_INVESTOR } from '../models/Redeem';
import { USER_GROUPS } from '../models/group';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { HeaderService } from '../header.service';
import { ProfileService } from '../profile.service';
import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';
import { AUCTIONS } from '../models/auctions';
import * as Globals from '../globals';
import { ExcelService } from 'app/excel.service';
const url = Globals.serviceUrl;

@Component({
  selector: 'app-download',
  templateUrl: './downloaddailyreport.component.html',
  styleUrls: ['./downloaddailyreport.component.css']
})
export class DownloadDailyReportComponent implements OnInit {
  authMenu: any;
  loading: boolean;
  series: any[];
  seriesId: any;
  cdOnline: string;
  paramSeries: any = { OPEN: false };
  tab: number = 1;
  auction: AUCTIONS;
  subregId: number = 0;
  dCloseOpt: any;
  dSettleOpt: any;
  userProfile: any;
  parts: any[];
  group: USER_GROUPS;
  param: any;
  dtFrom: any;
  dtTo: any;
  dtDari: any;
  dtSampai: any;
  hari: any;
  dailyreport: any[];
  constructor(private http: Http, public toastr: ToastsManager, vRef: ViewContainerRef, private headerService: HeaderService, private profileService: ProfileService, private route: ActivatedRoute, private router: Router, private excelService: ExcelService) {
    this.toastr.setRootViewContainerRef(vRef);
    this.authMenu = { M_FLAG: null };
    this.router.events.subscribe(event => {
      if (event instanceof RoutesRecognized) {
        if (event.url == '/dailyreport/0') {
          this.tab = 1;
          this.router.navigate(['/dailyreport/1']);
        }
      };
    });
  }
  ngOnInit() {
    this.dCloseOpt = { format: 'dd-mm-yyyy', icon: 'fa fa-calendar', autoclose: true, todayBtn: 'linked', todayHighlight: true };
    let id = +this.route.snapshot.params['id'];
    if (id == 0) {
      this.router.navigate(['/dailyreport/1']);
    }
    if (!this.profileService.userProfile) {
      this.profileService.signOut();
    } else {
      this.userProfile = this.profileService.userProfile;
      this.getSeries();
      this.authMenu = Globals.getAuthMenu(703, this.userProfile);
    }
  }

  dopenChanged(event: any) {
    /*this.dCloseOpt = { startDate: this.auction.OPEN_DATE, format: 'dd-mm-yyyy', icon: 'fa fa-calendar', autoclose: true, todayBtn: 'linked', todayHighlight: true };*/
    if (this.dtFrom > this.dtTo) {
      this.dtTo = this.dtFrom;
    }
    //this.setDSettle();
  }
  dcloseChanged(event: any) {
    //this.setDSettle();
  }

  seriesIdChanged(ev: any) {
    this.seriesId = ev.target.value;
    if (this.series.length > 0) {
      for (var i = 0; i < this.series.length; i++) {
        if (this.seriesId == this.series[i].SERIES_ID) {
          this.paramSeries = this.series[i];
          this.cdOnline = this.series[i].CD_ONLINE;
          break;
        }
      }
    }
    console.log(this.seriesId);
    console.log(this.cdOnline);
  }

  getSeries() {
    this.loading = true;
    this.http.get(url + 'ritel/downloadseries?t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.series = res.json();
        if (this.series.length > 0) {
          this.seriesId = this.series[0].SERIES_ID;
          this.cdOnline = this.series[0].CD_ONLINE;
          for (var i = 0; i < this.series.length; i++) {
            if (this.seriesId == this.series[i].SERIES_ID) {
              this.paramSeries = this.series[i];
              break;
            }
          }
          this.loading = false;
          if (this.userProfile.PARENT_GROUP_ID == null) {
          }
        } else if (this.series.length == 0) {
          this.toastr.warning('Tidak ada masa penawaran / Masa penawaran telah berakhir');
          this.loading = false;
        } else {
          this.loading = false;
        }
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  subregIdChanged(ev: any) {
    this.subregId = ev.target.value;
  }

  getDailyReport() {
    this.loading = true;
    this.dtDari = Globals.formatDateTime(this.dtFrom);
    this.dtSampai = Globals.formatDateTime(this.dtTo);
    this.hari = this.headerService.getApiFormatDate3(this.dtTo);
    if (this.cdOnline == "1") {
      this.http.get(url + 'ritel/dailyreport2?seriesId=' + this.seriesId + '&aucType=' + this.paramSeries.CD_AUC_TYPE + '&dtFrom=' + this.dtDari + '&dtTo=' + this.dtSampai + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
        .subscribe((res: Response) => {
          this.dailyreport = res.json();
          this.excelService.exportAsExcelFile(this.dailyreport, 'LaporanHarian_' + this.paramSeries.SERIES_NAME + '_' + this.hari);
          //onsole.log(this.series);
          this.loading = false;
        }, err => {
          console.log(err);
          this.toastr.error(Globals.errorMessage(err));
          this.loading = false;
        });
    }
    else {
      if (this.paramSeries.CD_AUC_TYPE == '1') {
        this.http.get(url + 'ritel/dailyreport?seriesId=' + this.seriesId + '&dtFrom=' + this.dtDari + '&dtTo=' + this.dtSampai + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
          .subscribe((res: Response) => {
            this.dailyreport = res.json();
            this.excelService.exportAsExcelFile(this.dailyreport, 'LaporanHarian_' + this.paramSeries.SERIES_NAME + '_' + this.hari);
            //onsole.log(this.series);
            this.loading = false;
          }, err => {
            console.log(err);
            this.toastr.error(Globals.errorMessage(err));
            this.loading = false;
          });
      }
      else {
        this.http.get(url + 'ritel/dailyreportredeem?seriesId=' + this.seriesId + '&dtFrom=' + this.dtDari + '&dtTo=' + this.dtSampai + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
          .subscribe((res: Response) => {
            this.dailyreport = res.json();
            this.excelService.exportAsExcelFile(this.dailyreport, 'LaporanHarian_' + this.paramSeries.SERIES_NAME + '_' + this.hari);
            //onsole.log(this.series);
            this.loading = false;
          }, err => {
            console.log(err);
            this.toastr.error(Globals.errorMessage(err));
            this.loading = false;
          });
      }
    }
  }

  CSVKSEI() {
    this.hari = this.headerService.getApiFormatDate3(this.dtTo);
    this.dtDari = Globals.formatDateTime(this.dtFrom);
    this.dtSampai = Globals.formatDateTime(this.dtTo);

  }


}



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/downloaddailyreport/downloaddailyreport.component.ts